import config from "../_helpers/config";
import { getAsync } from "../_helpers/adapters";


export async function getAuditLogs() {
  return getAsync(`${config.apiUrl}/audit-logs`);
}